import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface RequireAuthProps {
  children: React.ReactNode
}

/**
 * Guard de rota client-side (§1.9/D6).
 * Utilizadores não autenticados são redirecionados para /login,
 * preservando o deep-link via state.from.
 */
export default function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // Aguarda a hidratação do token do localStorage antes de redirecionar
  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
